import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class DataSharingService {

  private titleSource = new BehaviorSubject('SEASON SHARE');
  private holdData = new BehaviorSubject('');
  private groupId = new BehaviorSubject('');
  currentTitle = this.titleSource.asObservable();
  currentHoldData = this.holdData.asObservable();
  currentGroupId = this.groupId.asObservable();


  constructor() { }

  changeTitle(message: string) {
    this.titleSource.next(message);
  }

  holdDataService(data: any) {
    this.holdData.next(data);
  }

  getGroupId(groupId: string) {
    this.groupId.next(groupId);
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/data-sharing/data-sharing.service.ts